import { Box, Container } from '@mui/material';
import { Outlet, useParams } from '@tanstack/react-router';
import { AppHeader } from './AppHeader';
import { AppProvider } from '@context/index';
import { hideTanstackDevTools } from '@api/auth/config';
import { HubSpotTracker } from '../HubSpotTracker';
import { TanStackRouterDevtools } from '@tanstack/react-router-devtools';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';

export function RootLayout() {
  const { slug } = useParams({ strict: false });

  return (
    <>
      <Box sx={{ flexGrow: 1 }}>
        <Container maxWidth='xl' disableGutters>
          <AppProvider slug={slug}>
            <HubSpotTracker />
            <AppHeader />
            <main>
              <Outlet />
            </main>
          </AppProvider>
        </Container>
      </Box>
      {process.env.NODE_ENV === 'development' && !hideTanstackDevTools && (
        <>
          <TanStackRouterDevtools />
          <ReactQueryDevtools initialIsOpen={false} />
        </>
      )}
    </>
  );
}
